var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#F76241"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7386 6.34863C11.2323 6.34863 11.629 6.7554 11.6167 7.24896L11.5059 11.6806C11.4954 12.0969 11.155 12.429 10.7386 12.429V12.429C10.3222 12.429 9.98173 12.0969 9.97132 11.6806L9.8605 7.24896C9.84815 6.75541 10.2449 6.34863 10.7386 6.34863V6.34863ZM10.7503 15.1393C10.2006 15.1393 9.75611 14.6836 9.7678 14.1319C9.75611 13.5803 10.2006 13.1365 10.7503 13.1365C11.2649 13.1365 11.7211 13.5803 11.7211 14.1319C11.7211 14.6836 11.2649 15.1393 10.7503 15.1393Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.a0e5f793bc07c9ca7ce394a865064b49.svg";
export { ForwardRef as ReactComponent };